"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instalmentPlanTextFormatter = void 0;
const instalmentPlanTextFormatter = _ref => {
  let {
    amount,
    instalmentName,
    maxPaymentMonths,
    toCurrency
  } = _ref;
  if (!instalmentName) return;
  const monthlyDivisor = maxPaymentMonths || 12;
  const quarterlyDivisor = monthlyDivisor / 3;
  const divisors = {
    MONTHLY: Math.round(monthlyDivisor),
    QUARTERLY: Math.round(quarterlyDivisor)
  };
  const instalmentAmount = toCurrency(amount / divisors[instalmentName]);
  const instInterval = instalmentName === "QUARTERLY" ? "quarter" : "month";
  return `${instalmentAmount}/${instInterval}`;
};
exports.instalmentPlanTextFormatter = instalmentPlanTextFormatter;
exports.default = exports.instalmentPlanTextFormatter;